<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_cardsetting_banner.jpg')" alt="出金口座の登録方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="sup-page-title">
          出金口座の登録方法
        </h1>
        <p class="sup-page-lead">
          仮想通貨以外での出金をご利用の場合は、<br>
          事前に出金方法ごとに銀行口座 / eウォレットの口座 / アカウントを登録しておく必要があります。
        </p>
        <p class="sup-page-lead">
          出金申請時には、あらかじめ登録した銀行口座またはeウォレットを選択するだけで、<br>
          簡単に出金手続きを行うことができます。
        </p>
        <div class="sup-listbox">
          <p class="sup-listbox-title">
            出金口座の登録手順一覧
          </p>
          <div class="sup-listbox-list">
            <router-link class="sup-list-btn" to="/page/sup-cardsetting-bank">
              <span>銀行口座の登録方法</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-cardsetting-ewallet">
              <span>eウォレットアカウントの登録方法</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
            <router-link class="sup-list-btn" to="/page/sup-cardsetting-ewalletid">
              <span>各決済サービスのユーザーIDの確認方法</span>
              <span class="sup-list-btn-arrow">›</span>
            </router-link>
          </div>
        </div>
        <p class="sup-page-footnote sup-page-footnote--red">
          ※仮想通貨での出金は、出金画面にてアドレスを入力する方式のため、事前の登録は不要です。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'account-binding',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
